import Vue from "vue";
import vuetify from "./plugins/vuetify";

import "./plugins/veeValidate";
import "./plugins/vue2Filters";
import "./plugins/vueMoment";
import "./plugins/vueClipboard2";

import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

import App from "./App.vue";
import store from "./store";
import router from "./router";

import Amplify, * as AmplifyModules from "aws-amplify";
import Analytics from "@aws-amplify/analytics";

import { AmplifyPlugin } from "aws-amplify-vue";

import dictionary from "@/language/";
import { I18n } from "aws-amplify";
I18n.putVocabularies(dictionary);

import vuescroll from "vuescroll";
// You can set global config here.
Vue.use(vuescroll);

// If you need debug message from amplify
//window["LOG_LEVEL"] = "DEBUG";

//AWS Amplify - Added instructions for Electron #3357
//https://github.com/aws-amplify/amplify-js/pull/3357

Vue.use(AmplifyPlugin, AmplifyModules);

import config from "./aws-exports";

//Or If you use manual setup use
//import config from "./aws-exports-manual-setup";

Amplify.configure(config);

Analytics.autoTrack("pageView", {
  enable: true,
  type: "SPA"
});

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
